import { createContext } from 'react';
import noop from 'lodash/noop';

import { ModelOptions } from '../../../types';
import api from '../api';
import { ExchangeRate } from '../types';

import {
    BodyAddManyExchangeRates,
    ConvertCurrencyType,
    GetConvertRate,
    GetRatesByCurrenciesQueryBody
} from './BodyTypes';

interface Context<T> {
    get: (
        params?: Partial<T> & { date: number },
        options?: ModelOptions,
        updateState?: boolean
    ) => Promise<Array<T>>;
    post: (body: Partial<T>, updateState?: boolean, last?: boolean) => Promise<T>;
    put: (body: Partial<T>) => Promise<T>;
    data: T[];
    setData: (array: Array<T>) => void;
    error?: T | null | {};
}

export interface ExtendedContext extends Context<ExchangeRate> {
    addMany: (body: BodyAddManyExchangeRates) => Promise<ExchangeRate[]>;
    todayData: ExchangeRate[];
    allRates: ExchangeRate[];
    convertCurrency: ConvertCurrencyType;
    getConvertRate: GetConvertRate;
    getRateForDate: (base: any, quote: any, date: Date | number) => { exchangeRateSell: number; exchangeRateBuy: number } | null;
    getRatesByCurrencies: (query: GetRatesByCurrenciesQueryBody) => Promise<ExchangeRate[]>;
}

const ExchangeRatesContext = createContext<ExtendedContext>({
    get: api.get,
    post: api.post,
    put: api.put,
    data: [],
    setData: noop,
    error: null,
    todayData: [],
    allRates: [],
    addMany: api.addMany,
    convertCurrency: () => '',
    getConvertRate: () => 1,
    getRateForDate: () => null,
    getRatesByCurrencies: api.getRatesByCurrencies
});
export default ExchangeRatesContext;
